import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    // ECOM-2687: PDPs must open at the top on back navigation. Their reco
    // sliders load asynchronously (lazy-hydrated Odoscope), so the page is
    // still short when `page:finish` fires; restoring the browser's saved
    // position then overshoots the not-yet-rendered content and lands the user
    // at the footer. A fixed top is height-independent and is the agreed UX.
    // Non-PDP routes (e.g. PLP) keep their saved scroll position.
    const isProductDetail = to.meta.pageType === 'detail'

    // Returning immediately avoids racing Nuxt's page:finish hook with the
    // browser's saved-position restoration. Unlike a saved Y offset, top does
    // not depend on the final page height.
    if (isProductDetail) {
      // Only force top when the PDP is actually being entered. Selecting a size
      // rewrites the query in place (`?size=`), and Vue Router runs
      // scrollBehavior for that too — even when the query is unchanged, since it
      // deliberately re-scrolls duplicate navigations so same-anchor links work.
      // Forcing top there threw the user back up the page (ECOM-2793).
      if (to.path === from.path) {
        return false
      }
      return { top: 0 }
    }

    const { hooks } = useNuxtApp()

    const position =
      !savedPosition || from.name === null || from.path === '/'
        ? { top: 0 }
        : savedPosition

    // Bridges Nuxt's page:finish hook into Vue Router's scrollBehavior Promise contract;
    // there is no idiomatic Promise.resolve replacement here.
    // eslint-disable-next-line promise/avoid-new
    return new Promise((resolve) => {
      hooks.hookOnce('page:finish', async () => {
        await nextTick()
        resolve(position)
      })
    })
  },
}
